import { render, staticRenderFns } from "./TopHeaderAdmin.vue?vue&type=template&id=ea3c5fa4"
import script from "./TopHeaderAdmin.vue?vue&type=script&lang=js"
export * from "./TopHeaderAdmin.vue?vue&type=script&lang=js"
import style0 from "./TopHeaderAdmin.vue?vue&type=style&index=0&id=ea3c5fa4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports